import { z } from 'zod'

export const loginSchema = z.object({
  registration: z
    .string({ message: 'Matrícula é obrigatório' })
    .trim()
    .min(1, { message: 'Matrícula é obrigatório' }),
  password: z
    .string({ message: 'Senha é obrigatório' })
    .min(1, { message: 'Senha é obrigatório' }),
})

export type LoginSchema = z.infer<typeof loginSchema>
